export default () => {
  return !('scrollBehavior' in document.documentElement.style);
};
